module.exports = "https://cdn-challenge.mathletics.com/app/107/assets/images/63214e9bd97687a2ab058a0214595b12.svg";